@if ({
  model: model$ | async,
  products: products$ | async,
  compactMode: compactMode$ | async,
  }; as content) {
  <div class="cx-page">
    <cx-active-facets *smallerThan="DEVICE_SIZE.DESKTOP"></cx-active-facets>
    <section tabindex="-1" class="cx-page-section" [attr.aria-label]="'productList.productListResults' | cxTranslate">
      @if (currentViewMode$ | async; as viewMode) {
        <div>
          <div id="product-results-list" class="cx-product-container">
            <!-- Product list when using pagination -->
            @if (!isInfiniteScroll) {
              <div class="row m-t--20">
                @if (viewMode === ViewModes.Grid) {
                  @for (product of content.products; track product) {
                    <div class="col-12 col-sm-6 col-md-4 m-t-20">
                      <cx-product-grid-item [product]="product"></cx-product-grid-item>
                    </div>
                  }
                }
                @if (viewMode === ViewModes.List) {
                  @for (product of content.products; track product) {
                    <div class="col-12 m-t-20">
                      @if (content.compactMode) {
                        <product-list-item-compact [product]="product"></product-list-item-compact>
                      } @else {
                        <cx-product-list-item [product]="product"></cx-product-list-item>
                      }
                    </div>
                  }
                }
              </div>
              <cx-plp-pagination></cx-plp-pagination>
            } @else {
              @if (content.model) {
                <cx-product-scroll
                  [scrollConfig]="scrollConfig"
                  [model]="content.model"
                  [inputViewMode]="viewMode"
                ></cx-product-scroll>
              }
            }
            <!-- Product list when using infinite scroll -->
          </div>
        </div>
      }
    </section>
  </div>
}
